"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validators = exports.requiredIf = void 0;
var validator_1 = __importDefault(require("validator"));
var required = function (val) {
    var noNumberValidation = typeof val !== 'number' && (!val || !val.toString().length);
    return noNumberValidation && 'This field is required.';
};
var requiredDateRange = function (_a) {
    var start = _a[0], end = _a[1];
    var validation = !start || !end;
    return (validation &&
        "This field require".concat(!start && !end ? 'd' : !start ? ' start value' : ' end value', "."));
};
var email = function (value) {
    return !validator_1.default.isEmail(value) && "".concat(value, " is not a valid email.");
};
var lt = function (maxLength) { return function (value) {
    return value &&
        value.toString().length >= maxLength &&
        "The value must have less than ".concat(maxLength, " symbols.");
}; };
var lte = function (maxLength) { return function (value) {
    return value &&
        value.toString().length > maxLength &&
        "The value can only have a maximum of ".concat(maxLength, " symbols.");
}; };
var gt = function (minLength) { return function (value) {
    return value &&
        value.toString().length <= minLength &&
        "The value must be greater than ".concat(minLength, " symbols.");
}; };
var gte = function (minLength) { return function (value) {
    return value &&
        value.toString().length < minLength &&
        "The value must be greater than equal ".concat(minLength, " symbols.");
}; };
var exact = function (length) { return function (value) {
    return value &&
        value.toString().length !== length &&
        "The value must be ".concat(length, " symbols.");
}; };
var ltNumber = function (min) { return function (value) {
    return (!validator_1.default.isNumeric("".concat(min).toString()) ||
        !validator_1.default.isNumeric("".concat(value)) ||
        Number(value) > min) &&
        "The value must be less than ".concat(min, ".");
}; };
var gtNumber = function (max) { return function (value) {
    return (!validator_1.default.isNumeric("".concat(max).toString()) ||
        !validator_1.default.isNumeric("".concat(value)) ||
        Number(value) < max) &&
        "The value must be great than ".concat(max, ".");
}; };
var isLatLong = function () { return function (value) {
    return !validator_1.default.isLatLong(value.toString()) &&
        "The value ".concat(value, " is not a valid Longitude / Latitude.");
}; };
var isCreditCard = function () { return function (value) {
    return !validator_1.default.isCreditCard(value) &&
        "The value ".concat(value, " is not a valid Credit Card.");
}; };
var isMACAddress = function () { return function (value) {
    return !validator_1.default.isMACAddress(value) &&
        "The value ".concat(value, " is not a valid MAC Address.");
}; };
var isURL = function () { return function (value) {
    return !validator_1.default.isURL(value) && "The value ".concat(value, " is not a valid URL");
}; };
var isPhone = function (locale) {
    if (locale === void 0) { locale = 'en-US'; }
    return function (value) {
        return !!value &&
            !validator_1.default.isMobilePhone(value, locale) &&
            "The value ".concat(value, " is not a valid Phone");
    };
};
var isPostalCode = function () { return function (value) {
    return !validator_1.default.isPostalCode(value, 'US') &&
        "The value ".concat(value, " is not a valid Postal Code");
}; };
var isLatitude = function (value) {
    return (value &&
        !(Number.isFinite(Number(value)) &&
            Number(value) >= -90 &&
            Number(value) <= 90) &&
        "The value isn't a valid Latitude.");
};
var requiredIf = function (func) { return function (value) {
    return func() && exports.Validators.required(value);
}; };
exports.requiredIf = requiredIf;
var isLongitude = function (value) {
    return (value &&
        !(Number.isFinite(Number(value)) &&
            Number(value) >= -180 &&
            Number(value) <= 180) &&
        "The value isn't a valid Longitude.");
};
var isAlpha = function (value) {
    return !validator_1.default.isAlpha(value) && "The value must contain only letters";
};
var isAlphanumeric = function (value) {
    return !validator_1.default.isAlphanumeric(value) &&
        "The value must contain only letters and numbers";
};
var isNumeric = function (value) {
    return !validator_1.default.isNumeric(value) && "The value must contain only numbers";
};
exports.Validators = {
    exact: exact,
    lt: lt,
    lte: lte,
    email: email,
    required: required,
    requiredDateRange: requiredDateRange,
    gt: gt,
    gte: gte,
    ltNumber: ltNumber,
    gtNumber: gtNumber,
    isLatLong: isLatLong,
    isCreditCard: isCreditCard,
    isMACAddress: isMACAddress,
    isURL: isURL,
    isPhone: isPhone,
    isPostalCode: isPostalCode,
    isLatitude: isLatitude,
    isLongitude: isLongitude,
    requiredIf: exports.requiredIf,
    isNumeric: isNumeric,
    isAlpha: isAlpha,
    isAlphanumeric: isAlphanumeric
};
